import { Link, Outlet, useParams } from 'react-router-dom';
import { getCity } from '../data/locations';
import { NotFoundPanel } from './NotFoundPanel';
import { PhotoGallery } from './PhotoGallery';
import { focusRing } from './SiteHeader';

export function CityPanel() {
  const { slug } = useParams<{ slug: string }>();
  const city = getCity(slug);

  if (!city) return <NotFoundPanel />;

  return (
    <div key={city.id} className="animate-[fadein_.22s_ease] pb-12">
      <header className="flex items-start justify-between gap-3 px-6 pb-5 pt-7 lg:px-10 lg:pt-9">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-[#f2c66d]/90">{city.country}</p>
          <h2 className="mt-2 text-[32px] font-[580] leading-[1.05] tracking-[-0.02em] lg:text-[40px] 2xl:text-[44px]">
            {city.name}
          </h2>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.16em] text-white/55">
            {city.date} · {city.photos.length} photographs
          </p>
          <p className="mt-4 max-w-[60ch] text-[15px] leading-[1.6] text-white/70">{city.blurb}</p>
        </div>
        <Link
          to="/"
          aria-label="Back to globe"
          className={`grid h-11 w-11 shrink-0 place-items-center rounded-full border border-white/12 text-white/80 hover:bg-white/10 ${focusRing}`}
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
          </svg>
        </Link>
      </header>

      <div className="px-3 sm:px-6 lg:px-10">
        <PhotoGallery
          photos={city.photos}
          placeName={city.name}
          hrefFor={(p) => `photo/${p.id}`}
          eager={4}
          singleColumnOnPhones
        />
      </div>

      <Outlet />
    </div>
  );
}
